<template>
  <v-navigation-drawer
    id="core-navigation-drawer"
    v-model="calendarDrawer"
    app
    v-bind="$attrs"
    right
    temporary
    width="300"
  >
    <v-card class="mt-5" flat>
      <v-card-title class="font-weight-bold pa-4">Calendar View</v-card-title>
      <v-card-text class="ma-0 ml-0">
        <div class="calendar mb-5">
          <div class="calendar-icons">
            <div class="calendar--item">
              <v-btn
                class="mx-2"
                fab
                dark
                color="indigo"
                small
                outlined
                @click="setType('day'), setCalendarDrawer(!calendarDrawer)"
              >
                <v-icon dark>
                  mdi-view-day-outline
                </v-icon>
              </v-btn>
            </div>
            <div class="calendar--item">
              Day
            </div>
          </div>

          <div class="calendar-icons">
            <div class="calendar--item">
              <v-btn
                class="mx-2"
                fab
                dark
                color="indigo"
                small
                outlined
                @click="setType('week'), setCalendarDrawer(!calendarDrawer)"
              >
                <v-icon dark>
                  mdi-view-week-outline
                </v-icon>
              </v-btn>
            </div>
            <div class="calendar--item">
              Week
            </div>
          </div>

          <div class="calendar-icons">
            <div class="calendar--item">
              <v-btn
                class="mx-2"
                fab
                dark
                color="indigo"
                small
                outlined
                @click="setType('month'), setCalendarDrawer(!calendarDrawer)"
              >
                <v-icon dark>
                  mdi-calendar-month-outline
                </v-icon>
              </v-btn>
            </div>
            <div class="calendar--item">
              Month
            </div>
          </div>

          <div class="calendar-icons">
            <div class="calendar--item">
              <v-btn
                class="mx-2"
                fab
                dark
                color="indigo"
                small
                outlined
                @click="setType('4day'), setCalendarDrawer(!calendarDrawer)"
              >
                <v-icon dark>
                  mdi-calendar-blank
                </v-icon>
              </v-btn>
            </div>
            <div class="calendar--item">
              4 Days
            </div>
          </div>
        </div>
      </v-card-text>
    </v-card>

    <v-divider></v-divider>

    <v-row justify="center" class="mt-5">
      <div class="pa-1">
        <v-date-picker></v-date-picker>
      </div>
    </v-row>
  </v-navigation-drawer>
</template>

<script>
/*eslint-disablle */

import { mapMutations } from "vuex";

export default {
  data() {
    return {};
  },

  computed: {
    calendarDrawer: {
      get() {
        return this.$store.state.calendarDrawer;
      },
      set(val) {
        this.$store.commit("SET_CALENDAR_DRAWER", val);
      },
    },
  },

  methods: {
    ...mapMutations({
      setCalendarDrawer: "SET_CALENDAR_DRAWER",
      setType: "SET_TYPE",
    }),
  },
};
</script>

<style scoped>
.calendar {
  display: flex;
  justify-content: space-around;
}
.calendar-icons {
  display: inline-flex;
  align-items: center;
  flex-direction: column;
  margin-right: 10px;
}

.calendar--item {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 8px;
}
</style>
